// extracted by mini-css-extract-plugin
export default {"page":"fM","top_block":"gM","heading":"hM","inner_text":"iM","starter_text":"jM","starter_cta":"kM","summary_block":"lM","cartsummary_wrap":"mM","price":"nM","pricing_wrap":"oM","summary_block_mob":"pM","summary":"qM","pricing_heading":"rM","products_summary":"sM","summary_line":"tM","summary_price":"uM","summary_title":"vM"};
    if(module.hot) {
      // 1715632478163
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  